import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Devedor, Endereco, Telefone, EmailType, TipoPessoaEnum, TipoLinhaTelefonicaEnum } from '../shared/services/acordo-ressarcimento/api/models';
import { AppComponent } from '../app.component';
import { GuiaPostalService, DevedoresService, EscritoriosService } from '../shared/services/acordo-ressarcimento/api/services';
import { LoadingService } from '../shared/services/components/loading.service';
import { PsCPFValidator } from 'porto-seguro-guide';
import { CnpjAlfanumericoValidator } from '../shared/validators/cnpj-alfanumerico.validator';
import { CnpjUtils } from '../shared/utils/cnpj.utils';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-pagador-lote-fatura',
  templateUrl: './pagador-lote-fatura.component.html',
  styleUrls: ['./pagador-lote-fatura.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class PagadorLoteFaturaComponent implements OnInit {
  public formPagador: FormGroup;
  public telefoneDevedorForm: FormGroup;
  public emailDevedorForm: FormGroup;
  public edicaoDevedor = false;
  public loadingLista = false;
  public selected = '';
  source = [];
  columnsTemplate = [];
  private _submittedNovoDevedor = false;
  private devedor: Devedor = {};
  public listaEscritoriosFiltro: any[];
  public nomeEscritorioFiltro: any[];
  public codigoEscritorioSelecionado: number;
  public endereco: Endereco = {};
  public telefones: Telefone[];
  public emails: EmailType[];

  constructor(
    private formBuilder: FormBuilder,
    public escritorioService: EscritoriosService,
    public devedorService: DevedoresService,
    private loading: LoadingService,
    public guiaPostalService: GuiaPostalService,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.loading.open();

    this.devedor = undefined;
    this.criarFormDevedor();
    this.recuperaPagadorAlternativo();
  }

  private criarFormDevedor() {
    this.formPagador = this.formBuilder.group({
      cpfNovoDevedor: ['', PsCPFValidator()],
      cnpjNovoDevedor: ['', CnpjAlfanumericoValidator.validar()],
      telNovoDevedor: [''],
      emailNovoDevedor: [''],
      negativadoNovoDevedor: [''],
      codigoEndereco: Number,
      cepNovoDevedor: [''],
      tipoEnderecoNovoDevedor: [''],
      enderecoNovoDevedor: [''],
      numeroNovoDevedor: [''],
      complementoNovoDevedor: [''],
      bairroNovoDevedor: [''],
      cidadeNovoDevedor: [''],
      estadoNovoDevedor: [''],
      flagPagador: [null],
      tipoPessoa: ['0'],
      telefonesDevedor: this.formBuilder.array([]),
      emailsDevedor: this.formBuilder.array([]),
      escritorio: null,
      codigoEscritorio: null,
      codigoPessoa: null,
    });
  }

  public log(event) {
    console.log(event);
  }

  public recuperaPagadorAlternativo() {
    
    //codigo escritório fixo 2867 e 57 para teste, mudar depois
    var parametros: EscritoriosService.ObterEscritorioPagadorParams = {
      codigoEscritorio: 2867,
      codigoRamoSinistro: 57,
    };

    this.escritorioService.obterEscritorioPagador(parametros).subscribe(result => {

      if (result != null) {
        this.devedor = result;
        this.formPagador.controls['escritorio'].setValue(result.nome);
        this.formPagador.controls['codigoEscritorio'].setValue(result.codigoEscritorio);
        this.formPagador.controls['codigoPessoa'].setValue(result.codigoPessoa);
        this.formPagador.controls['negativadoNovoDevedor'].setValue(result.flagNegativado);
        this.formPagador.controls['flagPagador'].setValue(result.flagPagador);
        if (result.tipoPessoa == TipoPessoaEnum.JURIDICA) {
          this.formPagador.controls['tipoPessoa'].setValue('1');
          this.formPagador.controls['cnpjNovoDevedor'].setValue(result.cnpj);
          this.devedor.strCpfGrid = CnpjUtils.formatar(result.cnpj);
        } else if (result.tipoPessoa == TipoPessoaEnum.FISICA) {
          this.formPagador.controls['tipoPessoa'].setValue('0');
          this.formPagador.controls['cpfNovoDevedor'].setValue(result.cpf);
          this.devedor.strCpfGrid = result.strCpfGrid.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
        }

        if (result.telefones != null && result.telefones.length > 0) {
          let dddTelefone;
          let numeroTelefone;
          let telefoneCompleto;
          let valorTipoLinhaTelefonica;
          const telefoneControl = <FormArray>this.formPagador.controls['telefonesDevedor'];

          this.deleteRowTelefone(0);
          for (let i = 0; i < result.telefones.length; i++) {

            dddTelefone = result.telefones[i].codigoDDDTelefone;
            numeroTelefone = result.telefones[i].numeroTelefone;
            telefoneCompleto = String(dddTelefone) + String(numeroTelefone);

            if (result.telefones[i].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.FIXO) {
              valorTipoLinhaTelefonica = 0;
              telefoneCompleto = telefoneCompleto.replace(/(\d{2})(\d{4})(\d{4})/g, "(\$1) \$2-\$3");
            } else if (result.telefones[i].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.CELULAR) {
              valorTipoLinhaTelefonica = 1;
              telefoneCompleto = telefoneCompleto.replace(/(\d{2})(\d{5})(\d{4})/g, "(\$1) \$2-\$3");
            }
            this.devedor.strTelefoneGrid = telefoneCompleto;
            telefoneControl.push(this.formBuilder.group({ tipoTelefone: valorTipoLinhaTelefonica, telefone: telefoneCompleto }));
          }
        }

        if (result.emails != null && result.emails.length > 0) {
          this.deleteRowEmail(0);
          const emailControl = <FormArray>this.formPagador.controls['emailsDevedor'];
          for (let i = 0; i < result.emails.length; i++) {
            let emailNovoDevedor = result.emails[i].endereco;
            emailControl.push(this.formBuilder.group({ emailNovoDevedor }));
          }
        }

        if (result.endereco != null) {
          this.formPagador.controls['cepNovoDevedor'].setValue(result.endereco.cep);
          this.formPagador.controls['tipoEnderecoNovoDevedor'].setValue(result.endereco.tipoEndereco);
          this.formPagador.controls['enderecoNovoDevedor'].setValue(result.endereco.logradouro);
          this.formPagador.controls['numeroNovoDevedor'].setValue(result.endereco.numero);
          this.formPagador.controls['complementoNovoDevedor'].setValue(result.endereco.complemento);
          this.formPagador.controls['bairroNovoDevedor'].setValue(result.endereco.bairro);
          this.formPagador.controls['cidadeNovoDevedor'].setValue(result.endereco.cidade);
          this.formPagador.controls['estadoNovoDevedor'].setValue(result.endereco.estado);
        }
      }
      this.loading.close();
      this.loadingLista = false;
    }, error => {
      this.appComponent.createAlert('Este escritório não possui pagadores', 'error');
      this.loading.close();
      this.loadingLista = false;
    });
  }

  public getSubmittedDevedor() {
    return this._submittedNovoDevedor;
  }

  public openEditarDevedor() {
    this.edicaoDevedor = true;

    this.limparDadosDevedor();

    console.log("Pagador selecionado no index: " + this.formPagador.value['flagPagador']);

    if (this.devedor) {
      //-- Dados basicos 
      this.formPagador.controls['escritorio'].setValue(this.devedor.nome);
      this.formPagador.controls['negativadoNovoDevedor'].setValue(this.devedor.flagNegativado);
      this.formPagador.controls['flagPagador'].setValue(this.devedor.flagPagador);
      this.formPagador.controls['codigoPessoa'].setValue(this.devedor.codigoPessoa);

      if (this.devedor.tipoPessoa === TipoPessoaEnum.FISICA) {
        this.formPagador.controls['tipoPessoa'].setValue('0');
        this.formPagador.controls['cpfNovoDevedor'].setValue(this.devedor.cpf);
      } else {
        this.formPagador.controls['tipoPessoa'].setValue('1');
        this.formPagador.controls['cnpjNovoDevedor'].setValue(this.devedor.cnpj);
      }

      //- Emails
      const emailControl = <FormArray>this.formPagador.controls['emailsDevedor'];
      for (let i = 0; i < this.devedor.emails.length; i++) {
        let emailNovoDevedor = this.devedor.emails[i].endereco;
        if (emailNovoDevedor != undefined) {
          emailControl.push(this.formBuilder.group({ emailNovoDevedor }));
        }
      }

      //-- Telefones
      const telefoneControl = <FormArray>this.formPagador.controls['telefonesDevedor'];

      if (this.devedor.telefones != undefined) {
        let dddTelefone;
        let numeroTelefone;
        let telefoneCompleto;
        let valorTipoLinhaTelefonica;

        for (let i = 0; i < this.devedor.telefones.length; i++) {
          dddTelefone = this.devedor.telefones[i].codigoDDDTelefone;
          numeroTelefone = this.devedor.telefones[i].numeroTelefone;
          telefoneCompleto = String(dddTelefone) + String(numeroTelefone);
          valorTipoLinhaTelefonica = 0;

          if (this.devedor.telefones[i].tipoLinhaTelefonica == TipoLinhaTelefonicaEnum.FIXO || (this.devedor.telefones[i].tipoLinhaTelefonica == undefined && telefoneCompleto.length == 10)) {
            valorTipoLinhaTelefonica = 0;
            telefoneCompleto = telefoneCompleto.replace(/(\d{2})(\d{4})(\d{4})/g, "(\$1) \$2-\$3");
          } else if (this.devedor.telefones[i].tipoLinhaTelefonica === TipoLinhaTelefonicaEnum.CELULAR || (this.devedor.telefones[i].tipoLinhaTelefonica == undefined && telefoneCompleto.length == 11)) {
            valorTipoLinhaTelefonica = 1;
            telefoneCompleto = telefoneCompleto.replace(/(\d{2})(\d{5})(\d{4})/g, "(\$1) \$2-\$3");
          }
          telefoneControl.push(this.formBuilder.group({ tipoTelefone: valorTipoLinhaTelefonica, telefone: telefoneCompleto }));
        }
      }

      //-- Endereco
      this.formPagador.controls['codigoEndereco'].setValue(this.devedor.endereco.codigoEndereco);
      if (this.devedor.endereco.cep != undefined && this.devedor.endereco.cep.length == 8) {
        this.formPagador.controls['cepNovoDevedor'].setValue(this.devedor.endereco.cep.replace(/(\d{5})(\d{3})/g, "\$1-\$2"));
        this.pesquisarCEP();
      } else {
        this.formPagador.controls['cepNovoDevedor'].setValue(this.devedor.endereco.cep);
      }
      this.formPagador.controls['tipoEnderecoNovoDevedor'].setValue(this.devedor.endereco.tipoEndereco);
      this.formPagador.controls['enderecoNovoDevedor'].setValue(this.devedor.endereco.logradouro);
      this.formPagador.controls['numeroNovoDevedor'].setValue(this.devedor.endereco.numero);
      this.formPagador.controls['complementoNovoDevedor'].setValue(this.devedor.endereco.complemento);
      this.formPagador.controls['bairroNovoDevedor'].setValue(this.devedor.endereco.bairro);
      this.formPagador.controls['cidadeNovoDevedor'].setValue(this.devedor.endereco.cidade);
      this.formPagador.controls['estadoNovoDevedor'].setValue(this.devedor.endereco.estado);
    }
  }

  public onAbrirModal(evento) {
    console.log("Abrindo modal de devedor... ");
    if (!this.edicaoDevedor) {
      this.limparDadosDevedor();
    }
  }

  public onFecharModal() {
    console.log("Fechando modal... ");
    this.edicaoDevedor = false;
  }

  private limparDadosDevedor() {
    console.log("limpando devedores");
    this.formPagador.controls['escritorio'].setValue('');
    this.formPagador.controls['cpfNovoDevedor'].setValue('');
    this.formPagador.controls['cnpjNovoDevedor'].setValue('');
    this.formPagador.controls['negativadoNovoDevedor'].setValue(null);
    this.formPagador.controls['cepNovoDevedor'].setValue(null);
    this.formPagador.controls['tipoEnderecoNovoDevedor'].setValue(null);
    this.formPagador.controls['enderecoNovoDevedor'].setValue(null);
    this.formPagador.controls['numeroNovoDevedor'].setValue(null);
    this.formPagador.controls['complementoNovoDevedor'].setValue(null);
    this.formPagador.controls['bairroNovoDevedor'].setValue(null);
    this.formPagador.controls['cidadeNovoDevedor'].setValue(null);
    this.formPagador.controls['estadoNovoDevedor'].setValue(null);

    var telefonesArray = this.formPagador.get('telefonesDevedor') as FormArray;
    while (telefonesArray.length !== 0) {
      telefonesArray.removeAt(0);
    }

    var emailsArray = this.formPagador.get('emailsDevedor') as FormArray;
    while (emailsArray.length !== 0) {
      emailsArray.removeAt(0);
    }
  }

  public pesquisarCEP() {

    this.formPagador.controls['codigoEndereco'].setValue(null);
    var cep = this.formPagador.value['cepNovoDevedor'];

    console.log("Consultando o cep : " + cep);

    //-- So busca o cep se for digitado corretamente
    if (cep.length === 9) {

      var cepInicial = cep.substring(0, 5);
      var cepFinal = cep.substring(6, 9);

      var params: GuiaPostalService.ObterLogradourosParams = { numeroCepLogradouro: cepInicial, numeroCepComplementoLogradouro: cepFinal };

      this.guiaPostalService.obterLogradouros(params).subscribe(response => {
        this.formPagador.controls['codigoEndereco'].setValue(response.logradouros[0].codigoLogradouro);
        this.formPagador.controls['tipoEnderecoNovoDevedor'].setValue(response.logradouros[0].tipoLogradouro.nomeTipoLogradouro);
        this.formPagador.controls['enderecoNovoDevedor'].setValue(response.logradouros[0].nomeLogradouro);
        this.formPagador.controls['bairroNovoDevedor'].setValue(response.logradouros[0].bairro.nomeBairro);
        this.formPagador.controls['cidadeNovoDevedor'].setValue(response.logradouros[0].localidade.nomeLocalidade);
        this.formPagador.controls['estadoNovoDevedor'].setValue(response.logradouros[0].localidade.estado.siglaEstado);
      }, error => {
        this.appComponent.createAlert('Não foi possível obter o endereço pelo CEP.', 'error');
        console.log('Não foi possível obter o endereço  pelo CEP: ' + error);
      });
    }
  }

  public incluirTelefoneDevedor() {
    const control = <FormArray>this.formPagador.controls['telefonesDevedor'];
    control.push(this.formBuilder.group({ tipoTelefone: '0', telefone: '' }));
  }

  public incluirEmailDevedor() {
    const control = <FormArray>this.formPagador.controls['emailsDevedor'];
    control.push(this.formBuilder.group({ emailNovoDevedor: '' }));
  }

  public deleteRowTelefone(indexTelefone) {
    const control = <FormArray>this.formPagador.controls['telefonesDevedor'];
    control.removeAt(indexTelefone);
  }

  public deleteRowEmail(indexEmail) {
    const control = <FormArray>this.formPagador.controls['emailsDevedor'];
    control.removeAt(indexEmail);
  }

  private validarFormularioNovoDevedor(): boolean {
    let isCampoFocus = false;
    var isValido = true;

    if (this.formPagador.get('tipoPessoa').value == 0) {
      if (this.formPagador.get('cpfNovoDevedor').status === 'INVALID' && !this.formPagador.get('cpfNovoDevedor').untouched || !this.formPagador.value['cpfNovoDevedor']) {
        isValido = false;
        this.formPagador.controls['cpfNovoDevedor'].setErrors({ 'incorrect': true });
        if (!isCampoFocus) {
          document.getElementById('cpfNovoDevedor').focus(); isCampoFocus = true
        };
      }
    } else {
      if (this.formPagador.get('cnpjNovoDevedor').status === 'INVALID' && !this.formPagador.get('cnpjNovoDevedor').untouched || !this.formPagador.value['cnpjNovoDevedor']) {
        isValido = false;
        this.formPagador.controls['cnpjNovoDevedor'].setErrors({ 'incorrect': true });
        if (!isCampoFocus) {
          document.getElementById('cnpjNovoDevedor').focus(); isCampoFocus = true
        };
      }
    }
    if (this.formPagador.value['telefonesDevedor'].length === 0) {
      isValido = false;
      this.formPagador.controls['telefonesDevedor'].setErrors({ 'incorrect': true });
    } else {

      var telefonesArray = this.formPagador.get('telefonesDevedor') as FormArray;
      for (var i = 0; i < telefonesArray.length; i++) {

        if (telefonesArray.value[i].telefone.length < 14) {
          isValido = false;
          this.formPagador.controls['telefonesDevedor'].setErrors({ 'incorrect': true });
          break;
        }
      }
    }

    if (this.formPagador.value['emailsDevedor'].length === 0) {
      isValido = false;
      this.formPagador.controls['emailsDevedor'].setErrors({ 'incorrect': true });
    } else {

      var emailsArray = this.formPagador.get('emailsDevedor') as FormArray;
      for (var i = 0; i < emailsArray.length; i++) {

        if (emailsArray.value[i].emailNovoDevedor === '') {
          isValido = false;
          this.formPagador.controls['emailsDevedor'].setErrors({ 'incorrect': true });
          break;
        }

        if (emailsArray.value[i].status === 'INVALID') {
          isValido = false;
          this.formPagador.controls['emailsDevedor'].setErrors({ 'incorrect': true });
          break;
        }
      }
    }

    if (!this.formPagador.value['cepNovoDevedor'] || this.formPagador.value['cepNovoDevedor'].length < 9) {
      isValido = false;
      this.formPagador.controls['cepNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('cepNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formPagador.value['tipoEnderecoNovoDevedor']) {
      isValido = false;
      this.formPagador.controls['tipoEnderecoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('tipoEnderecoNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formPagador.value['enderecoNovoDevedor']) {
      isValido = false;
      this.formPagador.controls['enderecoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('enderecoNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formPagador.value['numeroNovoDevedor']) {
      isValido = false;
      this.formPagador.controls['numeroNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('numeroNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formPagador.value['bairroNovoDevedor']) {
      isValido = false;
      this.formPagador.controls['bairroNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('bairroNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formPagador.value['cidadeNovoDevedor']) {
      isValido = false;
      this.formPagador.controls['cidadeNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('cidadeNovoDevedor').focus(); isCampoFocus = true
      };
    }

    if (!this.formPagador.value['estadoNovoDevedor']) {
      isValido = false;
      this.formPagador.controls['estadoNovoDevedor'].setErrors({ 'incorrect': true });
      if (!isCampoFocus) {
        document.getElementById('estadoNovoDevedor').focus(); isCampoFocus = true
      };
    }
    return isValido;
  }

  public incluirDevedor(componenteModal) {

    if (this.edicaoDevedor) {
      this.alterarDevedor(componenteModal);
    } else {
      console.log("Incluindo novo devedor...");

      this._submittedNovoDevedor = true;

      if (!this.validarFormularioNovoDevedor()) {
        return;
      }

      this.devedor = {};

      //-- Dados basicos
      this.devedor.nome = this.formPagador.value['escritorio'];
      this.devedor.codigoPessoa = this.formPagador.value['codigoPessoa'];
      this.devedor.cpf = (this.formPagador.value['cpfNovoDevedor'] != undefined) ? this.formPagador.value['cpfNovoDevedor'].replace(/\./g, '').replace('-', '') : null;
      this.devedor.cnpj = (this.formPagador.value['cnpjNovoDevedor'] != undefined) ? CnpjUtils.normalizar(this.formPagador.value['cnpjNovoDevedor']) : null;
      this.devedor.flagNegativado = this.formPagador.value['negativadoNovoDevedor'];

      if (this.formPagador.get('tipoPessoa').value === '0') {
        this.devedor.strCpfGrid = this.formPagador.value['cpfNovoDevedor'].replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
        this.devedor.tipoPessoa = TipoPessoaEnum.FISICA;
      } else {
        this.devedor.strCpfGrid = CnpjUtils.formatar(this.formPagador.value['cnpjNovoDevedor']);
        this.devedor.tipoPessoa = TipoPessoaEnum.JURIDICA;
      }

      //-- Telefones
      this.devedor.telefones = [];
      var telefonesArray = this.formPagador.get('telefonesDevedor') as FormArray;
      this.devedor.strTelefoneGrid = telefonesArray.value[0].telefone.toString();
      for (var i = 0; i < telefonesArray.length; i++) {
        this.devedor.telefones[i] = {};
        this.devedor.telefones[i].codigoDDDTelefone = telefonesArray.value[i].telefone.toString().substring(1, 3);
        this.devedor.telefones[i].numeroTelefone = telefonesArray.value[i].telefone.toString().substring(4, telefonesArray.value[i].telefone.length).replace('-', '').trim();

        if (telefonesArray.value[i].tipoTelefone == 0) {
          this.devedor.telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.FIXO;
        } else if (telefonesArray.value[i].tipoTelefone == 1) {
          this.devedor.telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.CELULAR;
        }
      }

      //-- Emails
      this.devedor.emails = [];
      var emailsArray = this.formPagador.get('emailsDevedor') as FormArray;
      for (var i = 0; i < emailsArray.length; i++) {
        this.devedor.emails[i] = {};
        this.devedor.emails[i].endereco = emailsArray.value[i].emailNovoDevedor.toString();
      }

      //-- Endereco
      this.devedor.endereco = {};
      this.devedor.endereco.codigoEndereco = this.formPagador.value['codigoEndereco'];
      this.devedor.endereco.cep = this.formPagador.value['cepNovoDevedor'];
      this.devedor.endereco.tipoEndereco = this.formPagador.value['tipoEnderecoNovoDevedor'];
      this.devedor.endereco.logradouro = this.formPagador.value['enderecoNovoDevedor'];
      this.devedor.endereco.numero = this.formPagador.value['numeroNovoDevedor'];
      this.devedor.endereco.complemento = this.formPagador.value['complementoNovoDevedor'];
      this.devedor.endereco.bairro = this.formPagador.value['bairroNovoDevedor'];
      this.devedor.endereco.cidade = this.formPagador.value['cidadeNovoDevedor'];
      this.devedor.endereco.estado = this.formPagador.value['estadoNovoDevedor'];

      componenteModal.close();
      this.salvarPagador();
    }
  }

  public alterarDevedor(componenteModal) {

    this._submittedNovoDevedor = true;

    if (!this.validarFormularioNovoDevedor()) {
      return;
    }

    //-- Dados basicos
    this.devedor.nome = this.formPagador.value['escritorio'];
    this.devedor.codigoPessoa = this.formPagador.value['codigoPessoa'];
    this.devedor.cpf = this.formPagador.value['cpfNovoDevedor'].replace(/\./g, '').replace('-', '');
    this.devedor.cnpj = CnpjUtils.normalizar(this.formPagador.value['cnpjNovoDevedor']);
    this.devedor.score = Number(this.formPagador.value['scoreDevedor']);
    this.devedor.flagNegativado = this.formPagador.value['negativadoNovoDevedor'];
    this.devedor.flagCongenere = this.formPagador.value['congenereNovoDevedor'];
    this.devedor.flagPagador = null;

    if (this.formPagador.get('tipoPessoa').value === '0') {
      this.devedor.strCpfGrid = this.formPagador.value['cpfNovoDevedor'].replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
      this.devedor.tipoPessoa = TipoPessoaEnum.FISICA;
    } else {
      this.devedor.strCpfGrid = this.formPagador.value['cnpjNovoDevedor'].replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
      this.devedor.tipoPessoa = TipoPessoaEnum.JURIDICA;
    }

    //-- Telefones
    this.devedor.telefones = [];
    var telefonesArray = this.formPagador.get('telefonesDevedor') as FormArray;
    this.devedor.strTelefoneGrid = telefonesArray.value[0].telefone.toString();
    for (var i = 0; i < telefonesArray.length; i++) {
      this.devedor.telefones[i] = {};
      this.devedor.telefones[i].codigoDDDTelefone = telefonesArray.value[i].telefone.toString().substring(1, 3);
      this.devedor.telefones[i].numeroTelefone = telefonesArray.value[i].telefone.toString().substring(4, telefonesArray.value[i].telefone.length).replace('-', '').trim();

      if (telefonesArray.value[i].tipoTelefone == 0) {
        this.devedor.telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.FIXO;
      } else if (telefonesArray.value[i].tipoTelefone == 1) {
        this.devedor.telefones[i].tipoLinhaTelefonica = TipoLinhaTelefonicaEnum.CELULAR;
      }
    }

    //-- Emails
    this.devedor.emails = [];
    var emailsArray = this.formPagador.get('emailsDevedor') as FormArray;
    for (var i = 0; i < emailsArray.length; i++) {

      this.devedor.emails[i] = {};
      this.devedor.emails[i].endereco = emailsArray.value[i].emailNovoDevedor.toString();
    }

    //-- Endereco
    this.devedor.endereco.codigoEndereco = this.formPagador.value['codigoEndereco'];
    this.devedor.endereco.cep = this.formPagador.value['cepNovoDevedor'];
    this.devedor.endereco.tipoEndereco = this.formPagador.value['tipoEnderecoNovoDevedor'];
    this.devedor.endereco.logradouro = this.formPagador.value['enderecoNovoDevedor'];
    this.devedor.endereco.numero = this.formPagador.value['numeroNovoDevedor'];
    this.devedor.endereco.complemento = this.formPagador.value['complementoNovoDevedor'];
    this.devedor.endereco.bairro = this.formPagador.value['bairroNovoDevedor'];
    this.devedor.endereco.cidade = this.formPagador.value['cidadeNovoDevedor'];
    this.devedor.endereco.estado = this.formPagador.value['estadoNovoDevedor'];

    componenteModal.close();
    this.salvarPagador();
  }

  public salvarPagador() {
    this.loading.open();

    //dados fixos para teste 2867 e 57, mudar depois
    this.devedor.codigoEscritorio = 2867;
    this.devedor.codigoOrigemSistema = 67;

    this.escritorioService.salvarEscritorio(this.devedor).subscribe(result => {
      this.appComponent.createAlert(result.message, 'success');
      this.loading.close();
      this.loadingLista = false;
    }, error => {
      this.appComponent.createAlert('Não foi possível salvar o pagador', 'error');
      this.loading.close();
      this.loadingLista = false;
    });
  }
}
